// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_formBox__HEiq2 {
  display: flex;
  height: auto;
  width: calc(100% - 25vw);
}
@media (max-width: 556px) {
  .style_formBox__HEiq2 {
    width: 96%;
  }
}
.style_formBox__HEiq2 .style_sendMessageBlock__T9Wit {
  caret-color: #000000;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: auto;
  padding: 6px 8px;
  background-color: transparent;
  gap: 8px;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T {
  display: flex;
  align-items: end;
  position: relative;
  width: 100%;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_blockActions__V2tJ0 {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  bottom: 8px;
  left: 15px;
  gap: 8px;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_addFile__whhtN {
  display: flex;
  align-items: center;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_addFile__whhtN .style_imgPreview__bF-dE {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 40px;
  width: 40px;
  overflow: hidden;
  left: 4px;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_addFile__whhtN .style_imgPreview__bF-dE .style_imgInsert__Q3TIT {
  display: flex;
  position: absolute;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_addEmoji__F1Cjy {
  width: 24px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_borderBox__9ClxT {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  border: 1px solid #5f8fdf;
  flex: 1 1;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_sendMessageCtrl__Pi6bj {
  height: 53px;
  overflow-x: hidden;
  border-radius: 24px;
  border: 0 none;
  background-color: #ffffff;
  resize: none;
  font-size: 16px;
  margin-right: 24px;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_sendMessageCtrl__Pi6bj.style_typeOne__NfYnX {
  padding: 15px 16px 14px 156px;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_sendMessageCtrl__Pi6bj.style_typeTwo__K1Q\\+2 {
  padding: 15px 16px 14px 80px;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_sendMessageCtrl__Pi6bj::-webkit-scrollbar {
  width: 7px;
  background-color: transparent;
}
.style_formBox__HEiq2 .style_sendInputBlock__Qgn\\+T .style_sendMessageCtrl__Pi6bj::-webkit-scrollbar-thumb {
  background: rgba(196, 200, 212, 0.7960784314);
  border-radius: 7px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.style_formBox__HEiq2 .style_sendButton__Mc\\+T9 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_formBox__HEiq2 .style_sendButton__Mc\\+T9 button {
  height: 53px;
  width: 53px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5f8fdf;
  border-radius: 50%;
  border: none;
  padding: 0;
  position: relative;
}
.style_formBox__HEiq2 .style_sendButton__Mc\\+T9 button img {
  position: absolute;
  left: 55%;
  transform: translateX(-50%) scale(1.3);
}

.style_img-scroll__pUcHf {
  width: 48px;
  height: 50px;
  position: absolute;
  left: 55px;
  bottom: 0;
  transform: translateY(30%);
  display: inline-flex;
  align-items: center;
  align-content: center;
  padding: 4px;
  padding-bottom: 9px;
}

.style_send-message-scroll__qqRdg {
  color: black;
  overflow-y: scroll;
}

.style_send-message-scroll-without__6q2cW {
  color: black;
  overflow-y: hidden;
}

.style_send-message-ctrl__hamZ2 {
  border-radius: 24px;
  border: 0 none;
  background-color: #ffffff;
  resize: none;
  padding: 15px 16px 14px 126px;
  font-size: 16px;
  margin-right: 8px;
}

.style_send-message-ctrl__hamZ2::-webkit-scrollbar {
  width: 7px;
  background-color: transparent;
}

.style_send-message-ctrl__hamZ2::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 7px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

.style_send-message-ctrl__hamZ2::-webkit-scrollbar-thumb:hover {
  background: rgba(196, 200, 212, 0.7960784314);
}

.style_img-insert-cancel__HwPoc {
  position: absolute;
  display: inline-flex;
  width: 100%;
  height: 100%;
  left: 0px;
  padding-top: 14px;
  background-image: none;
  background: none;
  align-content: center;
}

.style_img-insert-cancel-ctrl__y9G8C {
  display: inline-block;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
  background-image: none;
  background: none;
  align-content: center;
}

.style_img-insert__K1Kzb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.style_img-insert-box__Rp7KO {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: 144px;
  height: 120px;
  overflow: hidden;
}

.style_img-insert-frame__DwxgU {
  width: 200px;
  height: 150px;
  margin-right: 5px;
}

.style_img-insert-preview__z72Wz {
  width: 100%;
  height: 100%;
}

.style_send-message-block__Dwrcr {
  caret-color: black;
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: auto;
  padding: 6px 8px;
  background-color: #ebeded;
  gap: 8px;
}

.style_send-message-wrapper__5Gy8O {
  display: flex;
  align-items: end;
  width: 100%;
}

.style_paper-clip__R5Fc8 {
  color: rgb(172, 172, 172);
  cursor: pointer;
}

.style_fileWrapper__2UFsO {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.style_btnFile__c5WnX {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  color: rgb(172, 172, 172);
  transform: translateY(1px);
  cursor: pointer;
}
.style_btnFile__c5WnX .style_previewImage__goIxn {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.style_btnFile__c5WnX .style_icon__TcDc2 {
  height: 100%;
  width: 100%;
  cursor: pointer;
}
.style_btnFile__c5WnX .style_wrapperIcon__CTajX {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 2px;
  border-radius: 5px;
  background-color: #dce1e6;
}
.style_btnFile__c5WnX.style_preview__hjFQM {
  color: #4a596a;
}
.style_btnFile__c5WnX:not(.style_preview__hjFQM):hover {
  transition: all 0.25s;
  color: #5f8fdf;
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/InputBlock/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,YAAA;EACA,wBAAA;AADF;AAGE;EALF;IAMI,UAAA;EAAF;AACF;AAEE;EACE,oBCXI;EDYJ,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,6BAAA;EACA,QAAA;AADJ;AAIE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAFJ;AAII;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;AAHR;AAKQ;EACE,aAAA;EACA,kBAAA;AAHV;AAQI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AANN;AASI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAPN;AAUI;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBClFE;EDoFF,YAAA;EACA,eAAA;EACA,kBAAA;AATN;AAWM;EACE,6BAAA;AATR;AAYM;EACE,4BAAA;AAVR;AAaM;EACE,UAAA;EACA,6BAAA;AAXR;AAcM;EACE,6CAAA;EACA,kBAAA;EACA,4BAAA;EAAA,oBAAA;AAZR;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAfJ;AAiBI;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBCjHS;EDkHT,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAfN;AAiBM;EACE,kBAAA;EACA,SAAA;EACA,sCAAA;AAfR;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,mBAAA;EACA,cAAA;EACA,yBClKM;EDmKN,YAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;AAlBF;;AA0BA;EACE,UAAA;EACA,6BAAA;AAvBF;;AA0BA;EACE,uBAAA;EACA,kBAAA;EACA,4BAAA;EAAA,oBAAA;AAvBF;;AA0BA;EACE,6CAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAvBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,WAAA;EACA,YAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,QAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,gBAAA;EACA,WAAA;AAzBF;;AA4BA;EACE,yBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AAzBF;AAqCE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAnCJ;AAsCE;EACE,YAAA;EACA,WAAA;EACA,eAAA;AApCJ;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBCnTU;AD8Qd;AAwCE;EACE,cC/Sa;ADyQjB;AAyCE;EACE,qBAAA;EACA,cCzTW;ADkRf","sourcesContent":["@import '../../../variables.scss';\n\n.formBox {\n  display: flex;\n  height: auto;\n  width: calc(100% - 25vw);\n\n  @media (max-width: 556px) {\n    width: 96%;\n  }\n\n  .sendMessageBlock {\n    caret-color: $black;\n    display: flex;\n    align-items: flex-end;\n    width: 100%;\n    height: auto;\n    padding: 6px 8px;\n    // background-color: $gray-box-border;\n    background-color: transparent;\n    gap: 8px;\n  }\n\n  .sendInputBlock {\n    display: flex;\n    align-items: end;\n    position: relative;\n    width: 100%;\n\n    .blockActions {\n      display: flex;\n      position: absolute;\n      align-items: center;\n      justify-content: center;\n      bottom: 8px;\n      left: 15px;\n      gap: 8px;\n    }\n\n    .addFile {\n      display: flex;\n      align-items: center;\n\n      .imgPreview {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        height: 40px;\n        width: 40px;\n        overflow: hidden;\n        left: 4px;\n\n        .imgInsert {\n          display: flex;\n          position: absolute;\n        }\n      }\n    }\n\n    .addEmoji {\n      width: 24px;\n      height: 40px;\n      display: inline-flex;\n      align-items: center;\n      cursor: pointer;\n    }\n\n    .borderBox {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 24px;\n      border: 1px solid $active-color;\n      flex: 1;\n    }\n\n    .sendMessageCtrl {\n      height: 53px;\n      overflow-x: hidden;\n      border-radius: 24px;\n      border: 0 none;\n      background-color: $white;\n      // border: 1px solid $active-color;\n      resize: none;\n      font-size: 16px;\n      margin-right: 24px;\n\n      &.typeOne {\n        padding: 15px 16px 14px 156px;\n      }\n\n      &.typeTwo {\n        padding: 15px 16px 14px 80px;\n      }\n\n      &::-webkit-scrollbar {\n        width: 7px;\n        background-color: transparent;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #c4c8d4cb;\n        border-radius: 7px;\n        transition: all 0.2s;\n      }\n    }\n  }\n\n  .sendButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    button {\n      height: 53px;\n      width: 53px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: $active-color;\n      border-radius: 50%;\n      border: none;\n      padding: 0;\n      position: relative;\n\n      img {\n        position: absolute;\n        left: 55%;\n        transform: translateX(-50%) scale(1.3);\n      }\n    }\n  }\n}\n\n.img-scroll {\n  width: 48px;\n  height: 50px;\n  position: absolute;\n  left: 55px;\n  bottom: 0;\n  transform: translateY(30%);\n  display: inline-flex;\n  align-items: center;\n  align-content: center;\n  padding: 4px;\n  padding-bottom: 9px;\n}\n\n.send-message-scroll {\n  color: black;\n  overflow-y: scroll;\n}\n\n.send-message-scroll-without {\n  color: black;\n  overflow-y: hidden;\n}\n\n.send-message-ctrl {\n  border-radius: 24px;\n  border: 0 none;\n  background-color: $white;\n  resize: none;\n  padding: 15px 16px 14px 126px;\n  font-size: 16px;\n  margin-right: 8px;\n}\n\n// .send-message-ctrl\n// {\n//   scrollbar-width: thin;\n// }\n\n.send-message-ctrl::-webkit-scrollbar {\n  width: 7px;\n  background-color: transparent;\n}\n\n.send-message-ctrl::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 7px;\n  transition: all 0.2s;\n}\n\n.send-message-ctrl::-webkit-scrollbar-thumb:hover {\n  background: #c4c8d4cb;\n}\n\n.img-insert-cancel {\n  position: absolute;\n  display: inline-flex;\n  width: 100%;\n  height: 100%;\n  left: 0px;\n  padding-top: 14px;\n  background-image: none;\n  background: none;\n  align-content: center;\n}\n\n.img-insert-cancel-ctrl {\n  display: inline-block;\n  align-items: center;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  background-image: none;\n  background: none;\n  align-content: center;\n}\n\n.img-insert {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  // padding-top: 5px;\n  // padding-right: 7px;\n}\n\n.img-insert-box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  width: 144px;\n  height: 120px;\n  overflow: hidden;\n}\n\n.img-insert-frame {\n  width: 200px;\n  height: 150px;\n  margin-right: 5px;\n}\n\n.img-insert-preview {\n  width: 100%;\n  height: 100%;\n}\n\n.send-message-block {\n  caret-color: black;\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  height: auto;\n  padding: 6px 8px;\n  background-color: #ebeded;\n  gap: 8px;\n}\n\n.send-message-wrapper {\n  display: flex;\n  align-items: end;\n  width: 100%;\n}\n\n.paper-clip {\n  color: rgb(172, 172, 172);\n  cursor: pointer;\n}\n\n.fileWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n}\n\n.btnFile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  color: rgb(172, 172, 172);\n  transform: translateY(1px);\n  cursor: pointer;\n\n  // .file {\n  //   position: absolute;\n  //   width: 100%;\n  //   height: 100%;\n  //   opacity: 0;\n  //   left: 0;\n  //   top: 0;\n  //   cursor: pointer;\n  // }\n\n  .previewImage {\n    object-fit: contain;\n    width: 100%;\n    height: 100%;\n  }\n\n  .icon {\n    height: 100%;\n    width: 100%;\n    cursor: pointer;\n  }\n\n  .wrapperIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 2px;\n    border-radius: 5px;\n    background-color: $gray-border;\n  }\n\n  &.preview {\n    color: $text-color-800;\n  }\n\n  &:not(.preview):hover {\n    transition: all 0.25s;\n    color: $active-color;\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `style_formBox__HEiq2`,
	"sendMessageBlock": `style_sendMessageBlock__T9Wit`,
	"sendInputBlock": `style_sendInputBlock__Qgn+T`,
	"blockActions": `style_blockActions__V2tJ0`,
	"addFile": `style_addFile__whhtN`,
	"imgPreview": `style_imgPreview__bF-dE`,
	"imgInsert": `style_imgInsert__Q3TIT`,
	"addEmoji": `style_addEmoji__F1Cjy`,
	"borderBox": `style_borderBox__9ClxT`,
	"sendMessageCtrl": `style_sendMessageCtrl__Pi6bj`,
	"typeOne": `style_typeOne__NfYnX`,
	"typeTwo": `style_typeTwo__K1Q+2`,
	"sendButton": `style_sendButton__Mc+T9`,
	"img-scroll": `style_img-scroll__pUcHf`,
	"send-message-scroll": `style_send-message-scroll__qqRdg`,
	"send-message-scroll-without": `style_send-message-scroll-without__6q2cW`,
	"send-message-ctrl": `style_send-message-ctrl__hamZ2`,
	"img-insert-cancel": `style_img-insert-cancel__HwPoc`,
	"img-insert-cancel-ctrl": `style_img-insert-cancel-ctrl__y9G8C`,
	"img-insert": `style_img-insert__K1Kzb`,
	"img-insert-box": `style_img-insert-box__Rp7KO`,
	"img-insert-frame": `style_img-insert-frame__DwxgU`,
	"img-insert-preview": `style_img-insert-preview__z72Wz`,
	"send-message-block": `style_send-message-block__Dwrcr`,
	"send-message-wrapper": `style_send-message-wrapper__5Gy8O`,
	"paper-clip": `style_paper-clip__R5Fc8`,
	"fileWrapper": `style_fileWrapper__2UFsO`,
	"btnFile": `style_btnFile__c5WnX`,
	"previewImage": `style_previewImage__goIxn`,
	"icon": `style_icon__TcDc2`,
	"wrapperIcon": `style_wrapperIcon__CTajX`,
	"preview": `style_preview__hjFQM`
};
export default ___CSS_LOADER_EXPORT___;
